import { Button, ButtonProps, forwardRef } from '@chakra-ui/react'
import { colors } from '@hb/shared'

export const ActionButton = forwardRef((props: ButtonProps, ref) => (
  <Button
    ref={ref}
    // fontFamily="Open Sans"
    fontWeight={700}
    // size='sm'
    lineHeight={1}
    bg="white"
    _hover={{
      bg: 'gray.100',
    }}
    _dark={{
      bg: 'blackAlpha.500',
      _hover: {
        bg: 'blackAlpha.600',
      },
    }}
    px={4}
    colorScheme="green"
    variant="outline"
    {...props}
  />
))

export const RoundedButton = forwardRef(({ colorScheme = 'sage', ...props }: ButtonProps, ref) => (
  <Button
    ref={ref}
    // fontFamily="Open Sans"
    fontWeight={500}
    // size='sm'
    // py={2}
    // px={3}
    bg={`${colorScheme}.50`}
    lineHeight={1}
    _hover={{
      bg: `${colorScheme}.100`,
    }}
    _dark={{
      bg: 'blackAlpha.500',
      _hover: {
        bg: 'blackAlpha.600',
      },
    }}
    px={4}
    colorScheme={colorScheme}
    borderRadius="full"
    variant="outline"
    {...props}
  />
))

export const SolidActionButton = forwardRef((props: ButtonProps, ref) => (
  <Button
    ref={ref}
    fontFamily="Open Sans"
    fontWeight={700}
    bg={props.colorScheme ? undefined : colors.green.hex}
    _dark={{ bg: props.colorScheme ? undefined : colors.green.hex }}
    color="white"
    py={2}
    lineHeight={1}
    textShadow="1px 1px 3px rgba(0,0,0,0.5)"
    px={4}
    variant="solid"
    {...props}
    _hover={{
      bg: 'green.400',
      boxShadow: 'inset 1px 1px 3px rgba(0,0,0,0.3)',
      ...props._hover,
    }}
  />
))

export const ToggleButton = forwardRef(
  ({ isActive, ...props }: ButtonProps & { isActive: boolean }, ref) => (
    <Button
      ref={ref}
      fontFamily="Open Sans"
      fontWeight={700}
      border="1px solid"
      borderColor={isActive ? colors.green.hex : 'gray.300'}
      bg={isActive ? colors.green.hex : 'white'}
      color={isActive ? 'white' : 'gray.600'}
      textShadow={isActive ? '1px 1px 3px rgba(0,0,0,0.5)' : undefined}
      _hover={{
        bg: isActive ? 'green.400' : 'gray.100',
        boxShadow: isActive ? 'inset 1px 1px 3px rgba(0,0,0,0.3)' : 'none',
        ...props._hover,
      }}
      px={4}
      variant="solid"
      {...props}
    />
  ),
)
